var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import Vue from "vue";
import { Component, Watch } from "vue-property-decorator";
import ExternalPlayer from "./ThePlayerExternalPlayer";
import ProgressBar from "./ThePlayerProgressBar";
import AudioInfo from "./ThePlayerAudioInfo";
import Controls from "./ThePlayerControls";
import CurrentPlaylist from "./ThePlayerCurrentPlaylist";
import _ from "lodash";
import PlayerEventBus from "@/EventBuses/ThePlayerEventBus";
var ThePlayer = (function (_super) {
    __extends(ThePlayer, _super);
    function ThePlayer() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.dialog = false;
        _this.room = "";
        _this.player = _this.$store.state.player;
        return _this;
    }
    ThePlayer.prototype.joinRoom = function () {
        this["$socket"].emit("join room", this.room);
    };
    ThePlayer.prototype.onStateChange = function (newVal, oldVal) {
        var player = this.player;
    };
    ThePlayer.prototype.onPositionChange = function (newPosition, oldPosition) {
        var _this = this;
        if (this.player.alteringPlaylist)
            return;
        this.$store.dispatch("setState", 0);
        PlayerEventBus.$emit("seekTo", 0);
        this.$nextTick(function () {
            _this.$store.dispatch("setState", 1);
        });
    };
    ThePlayer.prototype.onTimeChange = function (newTime) {
        if (newTime && newTime === this.player.duration) {
            if (this.player.repeat === 1) {
                PlayerEventBus.$emit("seekTo", 0);
            }
            else if ((_.last(this.player.playlist)["id"] === this.$store.getters.audio.id) && (this.player.repeat === 2)) {
                this.$store.dispatch("setPosition", 0);
            }
            else if (this.player.position < this.player.playlist.length - 1) {
                this.$store.dispatch("setPosition", this.player.position + 1);
            }
            else {
                this.$store.dispatch("setState", 0);
            }
        }
    };
    __decorate([
        Watch("player.state"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayer.prototype, "onStateChange", null);
    __decorate([
        Watch("player.position"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayer.prototype, "onPositionChange", null);
    __decorate([
        Watch("player.time"),
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", void 0)
    ], ThePlayer.prototype, "onTimeChange", null);
    ThePlayer = __decorate([
        Component({
            components: {
                "external-player": ExternalPlayer,
                "player-progress-bar": ProgressBar,
                "player-info": AudioInfo,
                "player-controls": Controls,
                "current-playlist": CurrentPlaylist,
            },
            sockets: {
                "connect": function () {
                },
                "join": function (user) {
                },
                "leave": function (user) {
                },
                "message": function (message) {
                }
            },
        })
    ], ThePlayer);
    return ThePlayer;
}(Vue));
export default ThePlayer;



//////////////////
// WEBPACK FOOTER
// ./~/ts-loader!./~/vue-loader/lib/selector.js?type=script&index=0!./src/components/ThePlayer/ThePlayer.vue
// module id = 267
// module chunks = 0